import React from 'react';
import { User, Monitor, Wifi, Globe, Database, Shield, ArrowRight } from 'lucide-react';

const SIGNAL_INPUTS = [
  { key: 'IDENTITY', label: 'Identity Signals', icon: User, color: 'var(--zt-identity)' },
  { key: 'DEVICE', label: 'Device Signals', icon: Monitor, color: 'var(--zt-device)' },
  { key: 'NETWORK', label: 'Network Signals', icon: Wifi, color: 'var(--zt-network)' },
  { key: 'APPLICATION', label: 'App Signals', icon: Globe, color: 'var(--zt-application)' },
  { key: 'DATA', label: 'Data Signals', icon: Database, color: 'var(--zt-data)' }
];

const PolicyDecisionLayer = ({ overlay }) => {
  const getPillarCoverage = (pillarCode) => {
    if (!overlay?.pillarCoverage) return null;
    return overlay.pillarCoverage.find(pc => pc.pillar_code === pillarCode);
  };

  return (
    <div className="pdp-layer">
      <div className="layer-header">
        <div className="layer-header-left">
          <Shield size={16} style={{ color: 'var(--color-primary)' }} />
          <span className="layer-title">Policy Decision Point (PDP)</span>
          <span className="layer-subtitle">Continuous verification engine — never trust, always verify</span>
        </div>
      </div>

      <div className="pdp-content">
        {/* Signal Inputs */}
        <div className="pdp-signals">
          {SIGNAL_INPUTS.map(signal => {
            const Icon = signal.icon;
            const coverage = getPillarCoverage(signal.key);

            return (
              <div key={signal.key} className="pdp-signal-card">
                <div
                  className="pdp-signal-icon"
                  style={{ backgroundColor: `${signal.color}22`, color: signal.color }}
                >
                  <Icon size={16} />
                </div>
                <span className="pdp-signal-label">{signal.label}</span>
                {overlay && coverage && (
                  <div
                    className="pdp-signal-coverage"
                    style={{ color: signal.color }}
                  >
                    {Math.round(coverage.coverage_percentage || 0)}%
                  </div>
                )}
                <ArrowRight size={12} className="pdp-signal-arrow" />
              </div>
            );
          })}
        </div>

        {/* Central PDP Engine */}
        <div className="pdp-engine">
          <div className="pdp-engine-inner">
            <Shield size={28} className="pdp-engine-icon" />
            <div className="pdp-engine-title">Policy Engine</div>
            <div className="pdp-engine-desc">Evaluates signals against policy</div>
            <div className="pdp-engine-principles">
              <span className="pdp-principle">Verify Explicitly</span>
              <span className="pdp-principle">Least Privilege</span>
              <span className="pdp-principle">Assume Breach</span>
            </div>
          </div>
        </div>

        {/* Decision outputs */}
        <div className="pdp-decisions">
          <div className="pdp-decision pdp-decision--allow">
            <span className="pdp-decision-label">Allow</span>
            <div className="pdp-decision-desc">Verified &amp; Compliant</div>
          </div>
          <div className="pdp-decision pdp-decision--conditional">
            <span className="pdp-decision-label">Conditional</span>
            <div className="pdp-decision-desc">Step-up Auth Required</div>
          </div>
          <div className="pdp-decision pdp-decision--deny">
            <span className="pdp-decision-label">Deny</span>
            <div className="pdp-decision-desc">Non-compliant / High Risk</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PolicyDecisionLayer;
